import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/shared/config/storeConfig';

export const useAppDispatch = () => useDispatch<AppDispatch>();
